import { render, staticRenderFns } from "./HonorsPage.vue?vue&type=template&id=49d74bbe&scoped=true"
import script from "./HonorsPage.vue?vue&type=script&lang=js"
export * from "./HonorsPage.vue?vue&type=script&lang=js"
import style0 from "./HonorsPage.vue?vue&type=style&index=0&id=49d74bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d74bbe",
  null
  
)

export default component.exports